'use client';

import { useBlockModalStore } from '@/stores/useBlockModalStore';
import Modal from '@/components/modal/Modal';
import Function from '@/(routers)/boards/editor/block/modal/Function';
import GpsDistance from '@/(routers)/boards/editor/block/modal/GpsDistance';
import IrSignal from '@/(routers)/boards/editor/block/modal/IrSignal';
import LedBar from '@/(routers)/boards/editor/block/modal/LedBar';
import RgbLed from '@/(routers)/boards/editor/block/modal/RgbLed';
import Speaker from '@/(routers)/boards/editor/block/modal/Speaker';
import Variable from '@/(routers)/boards/editor/block/modal/Variable';
import WifiModal from '@/(routers)/boards/editor/block/modal/Wifi';

export default function BlockModal() {
    const { isOpen, modalType, closeModal, onConfirm } = useBlockModalStore();
    const handleClose = onConfirm ?? closeModal;

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleClose}
            pcWidth="630px"
            pcHeight="550px"
            mbWidth="95%"
            mbHeight="90%"
            direction="center"
            zIndex={90}
        >
            {modalType === 'speaker' && <Speaker />}
            {modalType === 'rgb' && <RgbLed />}
            {modalType === 'led_bar' && <LedBar />}
            {modalType === 'ir' && <IrSignal />}
            {modalType === 'gps_distance' && <GpsDistance />}
            {modalType === 'variable' && <Variable />}
            {modalType === 'func' && <Function />}
            {modalType === 'wifi' && <WifiModal />}
        </Modal>
    );
}
